import { getVesselSession } from "../lib/vesselAuth";

const BASE_URL = (import.meta as any).env?.VITE_API_URL ?? "";

export interface VesselThread {
  id: string;
  vessel_id: string;
  contact_id: string | null;
  subject: string;
  contact_name: string | null;
  contact_role: string | null;
  contact_email: string | null;
  last_body: string | null;
  last_sender_type: "shore" | "vessel" | null;
  last_message_at: string | null;
  unread_count: number;
  created_at: string;
  updated_at: string;
}

export interface VesselThreadMessage {
  id: string;
  thread_id: string;
  sender_type: "shore" | "vessel";
  sender_name: string | null;
  sender_id: string | null;
  body: string;
  acknowledged_at: string | null;
  created_at: string;
}

export interface VesselTransfer {
  id: string;
  description: string;
  download_token: string;
  expires_at: string;
  direction: string;
  status: "pending" | "in_transit" | "delivered" | "cancelled";
  downloaded_at: string | null;
  created_at: string;
}

async function vFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const s = getVesselSession();
  if (!s) throw new Error("Not authenticated");

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${s.token}`,
    ...(init.headers as Record<string, string>),
  };

  const res = await fetch(`${BASE_URL}${path}`, { ...init, headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((body as { error: string }).error ?? res.statusText);
  }
  return res.json() as Promise<T>;
}

export const vesselPortalApi = {
  // Messages
  listThreads: () => vFetch<VesselThread[]>("/api/vessel/messages"),

  getThread: (threadId: string) =>
    vFetch<{ thread: VesselThread; messages: VesselThreadMessage[] }>(
      `/api/vessel/messages/${threadId}`
    ),

  sendMessage: (body: {
    thread_id?: string;
    contact_id?: string;
    subject?: string;
    body: string;
  }) =>
    vFetch<{ id: string; thread_id: string }>("/api/vessel/messages", {
      method: "POST",
      body: JSON.stringify(body),
    }),

  acknowledge: (messageId: string) =>
    vFetch<{ ok: boolean }>(`/api/vessel/messages/${messageId}/acknowledge`, {
      method: "POST",
    }),

  // Downloads
  listDownloads: () => vFetch<VesselTransfer[]>("/api/vessel/downloads"),
};
